"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORT_CURRENCY_LIST = void 0;
/**
* 目前支持的货币格式串列表
* @const
*/
exports.SUPPORT_CURRENCY_LIST = [
    {
        symbol: '¥',
        type: 'currency-chs',
        pattern: '"¥"#,##0_);[Red]\\("¥"#,##0\\)',
        pattern_decimal: '"¥"#,##0.00_);[Red]\\("¥"#,##0.00\\)',
    },
    {
        symbol: 'HK$',
        type: 'currency-hk',
        pattern: '[$HK$-C04]#,##0_);[Red]\\([$HK$-C04]#,##0\\)',
        pattern_decimal: '[$HK$-C04]#,##0.00_);[Red]\\([$HK$-C04]#,##0.00\\)',
    },
    {
        symbol: '$',
        type: 'currency-en',
        pattern: '\\$#,##0_);[Red]\\(\\$#,##0\\)',
        pattern_decimal: '\\$#,##0.00_);[Red]\\(\\$#,##0.00\\)',
    },
    {
        symbol: 'US$',
        type: 'currency-en',
        pattern: '\\U\\S\\$#,##0_);[Red]\\(\\U\\S\\$#,##0\\)',
        pattern_decimal: '\\U\\S\\$#,##0.00_);[Red]\\(\\U\\S\\$#,##0.00\\)',
    },
];
//# sourceMappingURL=currency-const.js.map